import type { IMe } from '@platform/core/types';

/**
 * Чи створив простір користувач («Створити робочий простір»), а не демо-дані прототипу: у такого простору закріплене — лише вибране під час
 * створення (сервер), без автозакріплення бази знань і CRM прототипу (crmPinned, kbPinned), бо новий простір прототипу має ці модулі лише
 * вибраними. Невідомий простір — не створений. Чиста функція.
 */
export function createdWorkspace(me: IMe | undefined, ws: string): boolean {
  return me?.workspaces.find((w) => w.id === ws)?.isDemo === false;
}
